<template>
  <span
    class="c-toggletip-container"
    role="status">
    <button
      ref="button"
      :aria-label="label"
      class="btn c-toggletip-btn"
      type="button"
      @click="handleToggletip">
      {{ buttonIcon }}
    </button>
    <span
      ref="bubble"
      :data-show="isShowing"
      class="c-toggletip-bubble">
      <slot/>
      <span data-popper-arrow/>
    </span>
  </span>
</template>

<script>
// Built with the following in mind:
// https://inclusive-components.design/tooltips-toggletips/#inclusivetoggletips
// Using popper.js to implement
import { createPopper } from '@popperjs/core'

export default {
  name: 'Toggletip',

  props: {
    label: {
      type: String,
      default: gettext('More information')
    },
    buttonIcon: {
      type: String,
      default: '?'
    }
  },

  data() {
    return {
      popper: null,
      isShowing: false
    }
  },

  methods: {
    setupPopper(button, toggletip) {
      this.popper = createPopper(button, toggletip, {
        placement: 'right',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 8],
            },
          },
        ],
      })
    },

    destroyPopper() {
      if (this.popper) {
        this.isShowing = false
        this.popper.destroy()
        this.popper = null
      }
    },

    handleToggletip(e) {
      if (this.isShowing) {
        this.destroyPopper()
      } else {
        this.setupPopper(this.$refs.button, this.$refs.bubble)
        this.isShowing = true
        // Without an update() call, the popper element won't position itself correctly at first
        // https://stackoverflow.com/a/46487439
        this.$nextTick(() => {
          this.popper.update()
        })
      }
    },

    handleCloseToggletip(e) {
      if (
        e.type === 'keydown' && e.keyCode === 27
        || e.type === 'blur'
        || e.type === 'click' && e.target !== this.$refs.button
      ) {
        this.destroyPopper()
      }
    }
  },

  mounted() {
    this.$refs.button.addEventListener('blur', this.handleCloseToggletip)
    document.addEventListener('keydown', this.handleCloseToggletip)
    document.addEventListener('click', this.handleCloseToggletip)
  },

}
</script>
